import React, { useState, useContext } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faIdCard,
  faUserTag,
  faNetworkWired,
  faUserCheck,
  faCreditCard,
  faGlobe,
  faUserPlus,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import MyContext from "../../../MyContext";

const ClientCreationPage = ({ Admin }) => {
  const { baseUrl, config } = useContext(MyContext);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    clientName: "",
    clientNumber: "",
    userType: "",
    onboardingType: "",
    onboardedBy: "",
    billing_name: "",
    allowed_ip: "",
    firstName: "",
    lastName: "",
    password: "",
    confirmPassword: "",
  });

  const userTypeOptions = [
    { value: "1", label: "Admin" },
    { value: "0", label: "Super User" },
    { value: "2", label: "Regular User" },
  ];

  const onboardingTypeOptions = [
    { value: "direct", label: "Direct Onboarding" },
    { value: "indirect", label: "Indirect Onboarding" },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));

    if (name === "confirmPassword" || name === "password") {
      if (
        formData.password &&
        formData.confirmPassword &&
        formData.password !== value
      ) {
        setPasswordError("Passwords do not match");
      } else {
        setPasswordError("");
      }
    }
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setFormData((prev) => ({
      ...prev,
      [name]: selectedOption.value,
    }));
  };
  const payload = {
    userid: Admin.pkid,
    clientName: formData.clientName,
    clientNumber: formData.clientNumber,
    userType: formData.userType,
    onboardingType: formData.onboardingType,
    onboardedBy: formData.onboardedBy,
    billing_name: formData.billing_name,
    allowed_ip: formData.allowed_ip,
    firstName: formData.firstName,
    lastName: formData.lastName,
    password: formData.password,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      setPasswordError("Passwords do not match");
      return;
    }
    setLoading(true);

    const addClient = async () => {
      try {
        const requiredFields = [
          "clientName",
          "clientNumber",
          "userType",
          "onboardingType",
          "firstName",
          "lastName",
        ];
        const missingFields = requiredFields.filter(
          (field) => !formData[field]
        );

        if (missingFields.length > 0) {
          throw new Error(
            `Please fill in all required fields: ${missingFields.join(", ")}`
          );
        }

        const response = await axios.post(
          `${baseUrl}/api/SuperAdmin/createClient`,
          payload,
          config
        );
        if (response.data.responseCode === "00") {
          toast.success(response.data.responseMessage);

          // Reset form
          setFormData({
            clientName: "",
            clientNumber: "",
            userType: "",
            onboardingType: "",
            onboardedBy: "",
            billing_name: "",
            allowed_ip: "",
            firstName: "",
            lastName: "",
          });
        } else {
          toast.error(response.data.responseMessage);
        }
      } catch (error) {
        toast.error("Something went wrong!");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    addClient();
  };

  const resetForm = () => {
    setFormData({
      clientName: "",
      clientNumber: "",
      userType: "",
      onboardingType: "",
      onboardedBy: "",
      billing_name: "",
      allowed_ip: "",
      firstName: "",
      lastName: "",
    });
  };
  const [passwordError, setPasswordError] = useState("");
  return (
    <Container fluid className="py-4 marginRight">
      <ToastContainer position="top-right" autoClose={5000} />

      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          {" "}
          <div className=" d-flex align-items-center">
            <FontAwesomeIcon icon={faUserPlus} className="me-2" />
            <h1 className="text-muted"> Create New Client</h1>
          </div>
          <div className="border border-0 w-100 shadow-none">
            <div className=" py-4">
              <Form onSubmit={handleSubmit}>
                <div className="p-3 border bg-white rounded mb-3">
                  {" "}
                  <Row className="mb-4">
                    <Col md={12} className="mb-3">
                      <h5 className="" style={{ color: "rgb(45,142,255)" }}>
                        Client Information
                      </h5>
                      <hr className="mt-0" />
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          <FontAwesomeIcon
                            icon={faUser}
                            className=" me-2"
                            style={{ color: "rgb(45,142,255)" }}
                          />
                          Client Name*
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="clientName"
                          value={formData.clientName}
                          onChange={handleInputChange}
                          placeholder="Enter client name"
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          <FontAwesomeIcon
                            icon={faIdCard}
                            className=" me-2"
                            style={{ color: "rgb(45,142,255)" }}
                          />
                          Client Number*
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="clientNumber"
                          value={formData.clientNumber}
                          onChange={handleInputChange}
                          placeholder="Enter client number"
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          <FontAwesomeIcon
                            icon={faUserTag}
                            className=" me-2"
                            style={{ color: "rgb(45,142,255)" }}
                          />
                          User Type*
                        </Form.Label>
                        <Select
                          name="userType"
                          options={userTypeOptions}
                          onChange={(option) =>
                            handleSelectChange(option, { name: "userType" })
                          }
                          placeholder="Select user type"
                          className="basic-select"
                          classNamePrefix="select"
                          value={
                            userTypeOptions.find(
                              (option) => option.value === formData.userType
                            ) || null
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          <FontAwesomeIcon
                            icon={faNetworkWired}
                            className=" me-2"
                            style={{ color: "rgb(45,142,255)" }}
                          />
                          Onboarding Type*
                        </Form.Label>
                        <Select
                          name="onboardingType"
                          options={onboardingTypeOptions}
                          onChange={(option) =>
                            handleSelectChange(option, {
                              name: "onboardingType",
                            })
                          }
                          placeholder="Select onboarding type"
                          className="basic-select"
                          classNamePrefix="select"
                          value={
                            onboardingTypeOptions.find(
                              (option) =>
                                option.value === formData.onboardingType
                            ) || null
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
                <div className="p-3 border bg-white rounded mb-3">
                  {" "}
                  <Row className="mb-4">
                    <Col md={12} className="mb-3">
                      <h5 className="text-primary">Additional Details</h5>
                      <hr className="mt-0" />
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          <FontAwesomeIcon
                            icon={faUserCheck}
                            className=" me-2"
                            style={{ color: "rgb(45,142,255)" }}
                          />
                          Onboarded By
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="onboardedBy"
                          value={formData.onboardedBy}
                          onChange={handleInputChange}
                          placeholder="Enter onboarding agent"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          <FontAwesomeIcon
                            icon={faCreditCard}
                            className=" me-2"
                            style={{ color: "rgb(45,142,255)" }}
                          />
                          Billing Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="billing_name"
                          value={formData.billing_name}
                          onChange={handleInputChange}
                          placeholder="Enter billing name"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={12} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          <FontAwesomeIcon
                            icon={faGlobe}
                            className=" me-2"
                            style={{ color: "rgb(45,142,255)" }}
                          />
                          Allowed IP Addresses
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="allowed_ip"
                          value={formData.allowed_ip}
                          onChange={handleInputChange}
                          placeholder="Enter allowed IP addresses (comma separated)"
                        />
                        <Form.Text className="text-muted">
                          Leave empty to allow all IP addresses. Use comma to
                          separate multiple IPs.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
                <div className="p-3 border bg-white rounded">
                  {" "}
                  <Row className="mb-4">
                    <Col md={12} className="mb-3">
                      <h5 className="" style={{ color: "rgb(45,142,255)" }}>
                        Primary Contact
                      </h5>
                      <hr className="mt-0" />
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          <FontAwesomeIcon
                            icon={faUser}
                            className=" me-2"
                            style={{ color: "rgb(45,142,255)" }}
                          />
                          First Name*
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleInputChange}
                          placeholder="Enter first name"
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          <FontAwesomeIcon
                            icon={faUser}
                            className=" me-2"
                            style={{ color: "rgb(45,142,255)" }}
                          />
                          Last Name*
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleInputChange}
                          placeholder="Enter last name"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          <FontAwesomeIcon
                            icon={faLock}
                            className="me-2"
                            style={{ color: "rgb(45,142,255)" }}
                          />
                          Password*
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="password"
                          value={formData.password}
                          onChange={handleInputChange}
                          placeholder="Enter password"
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          <FontAwesomeIcon
                            icon={faLock}
                            className="me-2"
                            style={{ color: "rgb(45,142,255)" }}
                          />
                          Confirm Password*
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="confirmPassword"
                          value={formData.confirmPassword}
                          onChange={handleInputChange}
                          placeholder="Confirm password"
                          required
                        />
                        {passwordError && (
                          <Form.Text className="text-danger">
                            {passwordError}
                          </Form.Text>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
                <Row className="mt-4">
                  <Col className="d-flex justify-content-end">
                    <Button
                      variant="secondary"
                      className="me-2"
                      onClick={resetForm}
                      type="button"
                    >
                      Reset
                    </Button>
                    <Button variant="primary" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                          />
                          Creating...
                        </>
                      ) : (
                        "Create Client"
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ClientCreationPage;
